export const visit = (vm, at) => {
at({ "en": { "integrations": { "title": "Seamlessly integrate your apps", "subtitle": "Over {{ count }} leading apps and web services available" } } });
};